<script lang="ts" setup>
import { usePlayerStore } from '~/stores/usePlayerStore'
import type { BibleBook, Chapter } from '~/types/bible'

const { chapter, book } = defineProps<{
  book: BibleBook
  chapter: Chapter
}>()

const playbackTrackingParams = {
  content_type: 'chapter',
  content_group: 'Bible',
  content_id: `${book.translation}-${book.code}-${chapter.chapter}`,
  content_path: `/bible/${book.translation}/${book.code}/${chapter.chapter}/`,
}

const playerStore = usePlayerStore()
const isCurrent = computed(() => playerStore.media?.id === `${book.translation}-${book.code}-${chapter.chapter}`)

const handlePlay = async () => {
  window.gtag('event', isCurrent.value ? 'content_resume' : 'content_play', playbackTrackingParams)

  if (isCurrent.value) {
    playerStore.play()
    return
  }

  playerStore.isLoading = true

  playerStore.media = {
    id: `${book.translation}-${book.code}-${chapter.chapter}`,
    title: book.title,
    subTitle: `Chapter ${chapter.chapter}`,
    logo: '',
    route: {
      name: 'bible-translation-bookCode-chapterNumber',
      params: { translation: book.translation, bookCode: book.code, chapterNumber: chapter.chapter },
    },
    source: chapter.audioUrl,
    sourceType: 'file',
    mediaType: 'chapter',
  }

  playerStore.play()
}

const handlePause = () => {
  window.gtag('event', 'content_pause', playbackTrackingParams)

  playerStore.pause()
}
</script>

<template>
  <Button v-if="playerStore.isLoading" class="size-12 px-0 rounded-full flex items-center">
    <Icon class="animate-spin" name="mingcute:loading-3-fill" size="28" />
  </Button>

  <Button
    v-else-if="!playerStore.isPlaying || !isCurrent"
    class="size-12 px-0 rounded-full flex items-center"
    @click="handlePlay"
  >
    <Icon name="ic:round-play-arrow" size="30" />
  </Button>

  <Button
    v-else-if="playerStore.isPlaying && isCurrent"
    class="size-12 px-0 rounded-full flex items-center"
    @click="handlePause"
  >
    <Icon name="ic:round-pause" size="30" />
  </Button>
</template>

<style scoped></style>
